import isNullOrUndefined from './isNullOrUndefined';

const getSplitColonId = (id: string): string => {
  if (isNullOrUndefined(id) || typeof id !== 'string') return '';
  return id.split(':')[1];
};

export default getSplitColonId;
